import comp from "./OtpInput";
export default comp;
